module.exports = __webpack_public_path__ + "img/blueMail2.3a29dd22.svg";